
import Link from '@/components/compat/Link';
import { usePathname } from '@/lib/navigation';
import { motion } from 'framer-motion';
import { ShieldX } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePainelSession } from '@/components/painel/rbac/painel-session-context';
import { painelButtonPrimaryClass, painelSurfaceAccentClass } from '@/components/painel/painel-styles';
import { canAccessPainelPath } from '@/lib/painel-rbac';
import { cn } from '@/lib/utils';

export function PainelAccessDenied() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      className="flex min-h-[min(70vh,640px)] items-center justify-center py-12"
    >
      <div
        className={cn(
          painelSurfaceAccentClass,
          'mx-auto max-w-lg px-8 py-10 text-center',
          'shadow-[0_0_60px_-16px_rgba(56,189,248,0.2)]'
        )}
      >
        <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-2xl bg-rose-500/15 ring-1 ring-rose-400/30">
          <ShieldX className="h-8 w-8 text-rose-300" aria-hidden />
        </div>
        <h1 className="font-poppins text-xl font-bold text-white sm:text-2xl">Acesso negado</h1>
        <p className="mx-auto mt-3 max-w-sm font-inter text-sm leading-relaxed text-slate-400">
          Você não possui permissão para acessar esta área.
        </p>
        <Button asChild className={cn(painelButtonPrimaryClass, 'mt-8 h-11 px-6')}>
          <Link href="/painel">Voltar ao Dashboard</Link>
        </Button>
      </div>
    </motion.div>
  );
}

type PainelRouteGuardProps = {
  children: React.ReactNode;
};

export function PainelRouteGuard({ children }: PainelRouteGuardProps) {
  const pathname = usePathname();
  const { role, hydrated } = usePainelSession();

  if (!hydrated) return null;

  if (!role || !canAccessPainelPath(role, pathname)) {
    return <PainelAccessDenied />;
  }

  return <>{children}</>;
}
